import defaultState from './defaultState'

const state = defaultState();

const getters = {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
};

const mutations = {
    resetState(state) {
        Object.assign(state, defaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};
